import { generatePath, Navigate, useParams } from 'react-router-dom';
import { PATH_COMPASS_PLUS, PATH_COMPASS_PLUS_RESET_PASSWORD } from '../Router';

const RedirectToCompassPlus = () => {
  const { route, extra } = useParams();
  const url = new URL(window.location.href);
  const searchParams = new URLSearchParams(url.search);

  const logoutParam = searchParams.get('logout');

  if (null != logoutParam) {
    return (
      <Navigate to={PATH_COMPASS_PLUS + '/?logout'} replace/>
    );
  }

  const resetParam = searchParams.get('reset');

  if (null != resetParam) {
    return (
      <Navigate to={`${PATH_COMPASS_PLUS}/?reset${'' !== resetParam ? `=${resetParam}` : ''}`} replace/>
    );
  }

  const resetPasswordSuccessParam = searchParams.get('reset-password-success');

  if (null != resetPasswordSuccessParam) {
    return (
      <Navigate to={PATH_COMPASS_PLUS + '/?reset-password-success'} replace/>
    );
  }

  if ('reset-password' === route) {
    return (
      <Navigate to={generatePath(PATH_COMPASS_PLUS_RESET_PASSWORD, {code: extra})} replace/>
    );
  }

  return (
    <Navigate to={PATH_COMPASS_PLUS} replace/>
  );
};


export default RedirectToCompassPlus;
